import { _, moment } from '_core';

import { DraftParams } from './types';

export const validate = (params: DraftParams, context?: { start_date: string; end_date: string }) => {
  const date = params.snapshot_date;

  if (_.isEmpty(date)) return ['Snapshot date is a required field.'];

  if (context) {
    if (moment(date).isBefore(moment(context.start_date))) return ['Snapshot date must be on or after the start date.'];
    if (moment(date).isAfter(moment(context.end_date))) return ['Snapshot date must be on or before the end date.'];
  }

  if (params.min_basket_weight !== null && params.min_basket_weight !== undefined) {
    if (params.min_basket_weight <= 0) return ['Min basket weight must be greater than 0%.'];
    if (params.min_basket_weight > 1) return ['Min basket weight must be less or equal to 100%.'];
  }

  if (params.max_etfs !== null && params.max_etfs !== undefined) {
    if (params.max_etfs <= 0) return ['Max ETFs must be greater than 0.'];
    if (params.max_etfs > 20) return ['Max ETFS must be less than or equal to 20.'];
  }

  if (!_.isEmpty(params.component_errors)) return params.component_errors;
  return [];
};
